import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollStatusHelper  {
    _originalTypeClassName = "zERP.BO.PayrollStatusHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollStatusHelper.translate = translateService;
}
this.PayrollStatusHelperKey = null;
this._key = this.PayrollStatusHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollStatusHelperKey:any;
get PayrollStatusHelperKey(): any {
    return this._PayrollStatusHelperKey;
  }
set PayrollStatusHelperKey(value: any) {
    this._PayrollStatusHelperKey = value;
    this._key = value;
  }

static GetPayrollStatusName(payrollStatus: any): any{switch (payrollStatus) {case Domain.PayrollStatus.Draft:
{
return this.translate.instant('Res_ENUM_PayrollStatus_Draft');}
case Domain.PayrollStatus.Calculating:
{
return this.translate.instant('Res_ENUM_PayrollStatus_Calculating');}
case Domain.PayrollStatus.Completed:
{
return this.translate.instant('Res_ENUM_PayrollStatus_Completed');}
case Domain.PayrollStatus.Cancelled:
{
return this.translate.instant('Res_ENUM_PayrollStatus_Cancelled');}
case Domain.PayrollStatus.Deleted:
{
return this.translate.instant('Res_ENUM_PayrollStatus_Deleted');}
default:
{
return "";}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollStatusHelperKey == null || $this.PayrollStatusHelperKey == 0;
            }


}